<template>
  <div id="customerRequest">
    <!-- 提示信息 -->
    <el-alert
      title="温馨提示：申请人信息如尚未准备完善，此步骤可临时跳过，待下单后，需尽快到控制台补齐材料。"
      type="warning"
      show-icon
      :closable="false"
    ></el-alert>
    <div class="content">
      <!-- 申请人信息 -->
      <el-form label-width="80px">
        <el-form-item label="申请人信息" :rules="[{required: true,trigger: 'blur' }]"></el-form-item>
        <div class="addInformation" @click="drawer = true">
          <i class="el-icon-plus"></i>
          <p>添加新信息</p>
        </div>
      </el-form>
      <!-- 复审证据材料 -->
      <el-form label-width="80px">
        <el-form-item label="复审证据材料" :rules="[{required: true,trigger: 'blur' }]"></el-form-item>
        <div class="addInformation" @click="table = true">
          <i class="el-icon-plus"></i>
          <p>添加新信息</p>
        </div>
      </el-form>
      <el-drawer
        :visible.sync="drawer"
        :direction="direction"
        :showClose="showClose"
        :withHeader="withHeader"
        :size="`50%`"
        style="overflow: auto"
      >
        <div class="drawerHead">
          <h2>申请人信息</h2>
        </div>
        <hr style="background-color: #D7D7D7; height: 1px; border: none;" />
        <div class="drawerCenter">
          <h3>填写申请人信息</h3>
          <el-form :label-position="labelPosition">
            <el-form-item label="申请人名称"></el-form-item>
            <el-input v-model="reviewInfo.applicantName" placeholder="请输入申请人名称"></el-input>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="统一社会信用代码"></el-form-item>
            <el-input v-model="reviewInfo.assistant" placeholder="请输入统一社会信用代码"></el-input>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item
              label="申请人类型"
              :rules="[{ required: true, message: '请选择申请人类型', trigger: 'blur' }]"
            ></el-form-item>
            <el-radio v-model="applyUser.applicantType" label="企业">企业</el-radio>
            <el-radio v-model="applyUser.applicantType" label="个人">个人</el-radio>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="申请人国籍" :rules="[{ required: true,  trigger: 'blur' }]"></el-form-item>
            <el-select
              v-model="applyUser.applicantNationality"
              placeholder="请选择活动区域"
              style="width: 100%"
            >
              <el-option
                :label="item.city"
                :value="item.value"
                v-for="(item,index) of diqu"
                :key="index"
              ></el-option>
            </el-select>
          </el-form>
          <el-form>
            <el-form-item
              label="申请人营业执照副本复印件"
              :rules="[{ required: true, message: '请上传申请人营业执照副本复印件', trigger: 'blur' }]"
              style="display: block"
            ></el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveLicenseDir"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              :file-list="fileList"
              accept="pdf"
              :http-request="fileUploadLicenseDir"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、需上传PDF格式</div>
            </el-upload>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="营业执照地址"
              style="display: block; margin-bottom: 40px"
              prop="licenseAddress"
            >
              <el-input
                placeholder="请输入营业执照地址"
                v-model="applyUser.licenseAddress"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item label="负责人姓名" style="display: block; margin-bottom: 40px" prop="headName">
              <el-input
                placeholder="请输入法定负责人/负责人姓名"
                v-model="applyUser.headName"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="负责人职务"
              style="display: block; margin-bottom: 50px"
              prop="headPosition"
            >
              <el-input
                placeholder="请输入负责人职务"
                v-model="applyUser.headPosition"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <h3>评审代理委托书</h3>
          <el-form :label-position="labelPosition">
            <el-form-item label="负责人职务">
              <span style="color: #0065FF; cursor: pointer;" @click="dLoad()">点击下载《评审代理委托书模板》</span>
            </el-form-item>
            <div style="margin-bottom: 20px; font-size: 12px; color: #BBB;">
              <p>重要提示</p>
              <p>— 上传委托书模板只需在右下角签字（个人）或盖章（企业），委托书的其他信息都不需要填写；</p>
              <p>—评审代理委托书上传JPG格式，像素款高不能大雨4000，小于600；</p>
              <p>—扫描或拍照前，请确保委托书模板纸面工整顺平，不能有皱褶、反光等；</p>
            </div>
            <el-upload
              class="upload-demo"
              list-type="picture-card"
              :action="pdfUploadUrl"
              multiple
              :http-request="fileUploadAttorney"
            >
              <i class="el-icon-plus" style="position: relative;">
                <span
                  class="el-upload__text"
                  style="position: absolute;left: -9px;top: 33px; font-size: 12px; "
                >上传图片</span>
              </i>
            </el-upload>
          </el-form>
          <h3>联系人信息</h3>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="联系人姓名"
              style="display: block; margin-bottom: 40px"
              prop="contactName"
            >
              <el-input placeholder="请输入联系人" v-model="applyUser.contactName" style="display: block"></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="联系人电话"
              style="display: block; margin-bottom: 40px"
              prop="contactPhone"
            >
              <el-input
                placeholder="请输入联系人电话"
                v-model="applyUser.contactPhone"
                style="display: block"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="联系人邮箱"
              style="display: block; margin-bottom: 40px"
              prop="contactEmail"
            >
              <el-input
                placeholder="请输入联系人邮箱"
                v-model="applyUser.contactEmail"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="联系人地址"
              style="display: block; margin-bottom: 40px"
              prop="contactAddress"
            >
              <el-input
                placeholder="请输入联系人地址"
                v-model="applyUser.contactAddress"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="applyUser" :rules="rules">
            <el-form-item
              label="联系人邮编"
              style="display: block; margin-bottom: 50px"
              prop="contactZipCode"
            >
              <el-input
                placeholder="请输入联系人邮编"
                v-model="applyUser.contactZipCode"
                style="display: block"
                maxlength="6"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <hr style="background-color: #D7D7D7; height: 1px; border: none;" />
        <div class="drawerFooter">
          <el-button @click="changeAppli()">保存</el-button>
          <el-button @click="drawer = false">暂存</el-button>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="table"
        :direction="direction"
        :showClose="showClose"
        :withHeader="withHeader"
        :size="`50%`"
        style="overflow: auto"
      >
        <div class="drawerHead">
          <h2>商标驳回复审材料</h2>
        </div>
        <hr style="background-color: #D7D7D7; height: 1px; border: none;" />
        <div class="drawerCenter">
          <h3>填写证据材料</h3>
          <el-form :label-position="labelPosition" style="position: relative;">
            <el-form-item label="是否需要补充材料" :rules="[{required: true,trigger: 'blur' }]"></el-form-item>
            <el-radio v-model="askForData.isNeedSup" :label="1">是</el-radio>
            <el-radio v-model="askForData.isNeedSup" :label="0">否</el-radio>
            <el-tooltip class="item" effect="dark" content="提示信息" placement="right">
              <img
                src="@/assets/imgs/brandReview/putRecord/次级提醒 copy 2@2x.png"
                alt
                style="position: absolute; left: 130px; top: 11px; height: 18px"
              />
            </el-tooltip>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="证据目录">
              <span style="color: #0065FF; cursor: pointer;" @click="loadEvidence">点击下载《证据目录模板》</span>
            </el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveEvidenceDir"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :file-list="fileList"
              :http-request="fileUploadEvidenceDir"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、需上传PDF格式</div>
              <div slot="tip" class="el-upload__tip">2、需上传证据内容的，必须上传证据目录。</div>
            </el-upload>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="证据内容">
              <!-- <span style="color: #0065FF; cursor: pointer;">点击下载《证据内容模板》</span>  -->
            </el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveEvidenceCon"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :file-list="fileList"
              :http-request="fileUploadEvidenceCon"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、需上传PDF格式</div>
            </el-upload>
          </el-form>
          <h3>驳回复审分割情况</h3>
          <el-form :label-position="labelPosition" style="position: relative;">
            <el-form-item label="是否分割" :rules="[{ required: true,  trigger: 'blur' }]"></el-form-item>
            <el-radio v-model="askForData.division" :label="1">是</el-radio>
            <el-radio v-model="askForData.division" :label="0">否</el-radio>
            <el-tooltip class="item" effect="dark" content="提示信息" placement="right">
              <img
                src="@/assets/imgs/brandReview/putRecord/次级提醒 copy 2@2x.png"
                alt
                style="position: absolute; left: 90px; top: 11px; height: 18px"
              />
            </el-tooltip>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="分割申请书">
              <span style="color: #0065FF; cursor: pointer;">点击下载《分割申请书模板》</span>
            </el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveDivisionDir"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :file-list="fileList"
              :http-request="fileUploadDivisionDir"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、需上传PDF格式</div>
            </el-upload>
          </el-form>
          <h3>复审申请内容</h3>
          <el-form :label-position="labelPosition" :model="askForData" :rules="rules">
            <el-form-item label="评审请求与法律依据" prop="rrlb" style="display: block; margin-bottom: 40px">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="askForData.rrlb"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition" :model="askForData" :rules="rules">
            <el-form-item label="主要的事实与理由" prop="far" style="display: block; margin-bottom: 40px">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="askForData.far"
                style="display: block"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="事实与理由" :rules="[{required: true,trigger: 'blur' }]">
              <span style="color: #0065FF; cursor: pointer;" @click="downLoad()">点击下载《事实与理由申请书模板》</span>
            </el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveFarDir"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :file-list="fileList"
              :http-request="fileUploadFarDir"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、请上传评审的事实与理由，需上传PDF格式</div>
            </el-upload>
          </el-form>
          <h3>送达及其他材料</h3>
          <el-form :label-position="labelPosition">
            <el-form-item label="送达证据"></el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveEvidenceSend"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              :file-list="fileList"
              :http-request="fileUploadEvidenceSend"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">非电子送达方式受到驳回申请书的，请上传PDF格式的送达证据</div>
            </el-upload>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="其他有关说明文件"></el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveExplain"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :http-request="fileUploadExplain"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传PDF格式文件</div>
            </el-upload>
          </el-form>
          <el-form :label-position="labelPosition">
            <el-form-item label="与原代理接触关系声明书"></el-form-item>
            <el-upload
              class="upload-demo"
              :action="pdfUploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemoveRmLicense"
              :before-remove="beforeRemove"
              multiple
              :before-upload="beforeAvatarUpload"
              accept="pdf"
              :file-list="fileList"
              :http-request="fileUploadRmLicense"
            >
              <el-button size="small" type="primary">上传</el-button>
              <div slot="tip" class="el-upload__tip">1、原代理非“汉唐信通”必须上传</div>
              <div slot="tip" class="el-upload__tip">2、请上传PDF格式文件</div>
            </el-upload>
          </el-form>
        </div>
        <hr style="background-color: #D7D7D7; height: 1px; border: none;" />
        <div class="drawerFooter">
          <el-button @click="changeEvi()">保存</el-button>
          <el-button @click="table = false">暂存</el-button>
        </div>
      </el-drawer>
    </div>
    <div class="footer">
      <div class="matter">
        <el-button
          @click="$router.push('/brandReview/selfHelp/agentInformation')"
          style="width: 165px; text-align: center;"
        >下一步（跳过）</el-button>
        <el-button
          @click="$router.go(-1)"
          style="background: #FFF; color: #FF6A01; border: 1px solid #FF6A01;"
        >上一步</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { getOss } from "@/api/tmTools.js";
import { downLoadFacts, dLoadRevie, bsubmit } from "@/api/fill.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      data: {},
      pdfUploadUrl: "",
      textarea: "",
      fileList: [],
      select: "",
      radio: "1",
      type: "3",
      table: false, //复审材料的弹出层
      drawer: false, //申请人信息的弹出层
      direction: "rtl",
      showClose: false,
      withHeader: false,
      labelPosition: "left",
      downLoadUrl: "",
      // 申请人信息
      applyUser: {
        applicantName: "", //申请人名称
        socialCreditCode: "", //统一信用代码
        applicantType: "企业", // 申请人类型: 企业 个人
        applicantNationality: "大陆", // 申请人国籍
        licenseAddress: "", // 营业执照地址
        headName: "", //负责人姓名
        contactName: "", // 联系人姓名
        headPosition: "", //负责人职务
        contactPhone: "", // 联系人电话
        contactEmail: "", // 联系人邮箱
        contactAddress: "", // 联系人地址
        contactZipCode: "", // 邮政编码
        entrust: "", //评审代理委托书的url
        licenseDir: "", //营业执照的图片地址url
      },
      // 复审材料证据
      askForData: {
        isNeedSup: 1, // 是否需要补充材料: 0 否 1 是
        division: 1, // 是否分割
        rrlb:
          "根据《中华人民共和国商标法》第三十四条的规定，申请人请求中华人民共和国知识产权局商标局对申请商标在复审产品和服务商予以初步审定", // 评审需求与法律依据
        far: "",
        farDir: "", // 事实与理由 文件
        divisionDir: "", // 分割申请书
        explain: "", // 其他有关说明文件
        rmLicense: "", //与原代理解除关系声明书
        evidenceDir: "", // 证据目录 文件
        evidenceCon: "", // 证据内容 文件
        evidenceSend: "", // 送达证据 文件
      },
      diqu: [
        { city: "大陆", value: "大陆" },
        { city: "中国香港", value: "中国香港" },
        { city: "中国台湾", value: "中国台湾" },
        { city: "海外", value: "海外" },
      ],
      rules: {
        licenseAddress: [
          { required: true, message: "营业执照地址不能为空", trigger: "blur" },
        ],
        headName: [
          { required: true, message: "负责人姓名不能为空", trigger: "blur" },
        ],
        headPosition: [
          { required: true, message: "负责人职务不能为空", trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "联系人姓名不能为空", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "联系人电话不能为空", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入电话的正确格式",
            trigger: "blur",
          },
        ],
        contactEmail: [
          { required: true, message: "联系人邮箱不能为空", trigger: "blur" },
          {
            required: true,
            pattern: /^\w+@[a-z0-9]+\.[a-z]{2,4}$/,
            message: "请输入邮箱正确格式",
            trigger: "blur",
          },
        ],
        contactAddress: [
          { required: true, message: "联系人地址不能为空", trigger: "blur" },
        ],
        contactZipCode: [
          { required: true, message: "邮政编码不能为空", trigger: "blur" },
        ],
        rrlb: [
          {
            required: true,
            message: "评审需求与法律依据不能为空",
            trigger: "blur",
          },
        ],
        far: [
          {
            required: true,
            message: "主要的事实与理由不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      // applicantName: (state) => state.brandReview.reviewInfo.applicantName, //申请人名称
      // socialCreditCode: (state) => state.brandReview.reviewInfo.assistant, //统一信用代码
      reviewInfo: (state) => state.brandReview.reviewInfo, //首页所有信息
      applicantInfo: (state) => state.brandReview.applicantInfo,
      evidenceMaterial: (state) => state.brandReview.evidenceMaterial,
      orderInfo: (state) => state.brandReview.orderInfo,
    }),
  },
  created() {
    getOss().then((res) => {
      if (res.status == 0) {
        this.data = res.data;
        this.data.key = this.setKey();
        this.pdfUploadUrl = res.data.url;
      }
    });
  },

  mounted() {
    this.$store.commit("qffillmaterials/changeActivedIndex", 1);
    let newList = [];
    this.reviewInfo.nclexist.forEach((item) => {
      newList.push(item.small_name);
    });
    let nclist = newList.join("、");
    this.askForData.far = `申请人对${this.reviewInfo.postNo}号《商标部分驳回通知书》驳回第${this.reviewInfo.caseNumber}号商标（一下简称“申请商标”）在${this.reviewInfo.brandType}类“${nclist}”服务上的注册申请不服，根据《商标法》第三十四条的规定，现于法定期限向贵局提出驳回复审申请`; // 主要的事实与理由
  },
  methods: {
    //下载证据目录模板
    loadEvidence() {
      window.open(
        "https://gsb-zc.oss-cn-beijing.aliyuncs.com/%E5%95%86%E6%A0%87%E8%AF%84%E5%AE%A1%E6%A1%88%E4%BB%B6%E7%94%B3%E8%AF%B7%E6%9D%90%E6%96%99%E7%9B%AE%E5%BD%95"
      );
    },
    //下载评审代理委托书模板
    dLoad() {
      let params = {
        applyName: this.$store.state.brandReview.reviewInfo.rejData.applicant, //申请人
        addr: this.$store.state.brandReview.reviewInfo.rejData.address, //通信地址
        name: this.applyUser.headName, //负责人
        duty: this.applyUser.headPosition, //职务
        type: this.$store.state.brandReview.reviewInfo.agent, //商标类别
        tm_name: this.$store.state.brandReview.reviewInfo.type, //商标图样
        num: this.$store.state.brandReview.reviewInfo.caseNumber, //申请号
      };
      dLoadRevie(params).then((res) => {
        console.log(params, "params");
        if (res.status == 0) {
          console.log(res.data);
          window.open(res.data.word_url);
        }
      });
    },
    //下载事实与理由模板
    downLoad() {
      let params = {
        applicantName: this.$store.state.brandReview.reviewInfo.applicantName, //申请人
        askforId: this.$store.state.brandReview.reviewInfo.caseNumber, //申请号
        addr: this.$store.state.brandReview.reviewInfo.rejData.address, //通信地址
        dutyName: this.applyUser.headName, //负责人
        duty: this.applyUser.headPosition, //职务
        tradeType: this.$store.state.brandReview.reviewInfo.brandType, //商标类别
        tradeImg: this.$store.state.brandReview.reviewInfo.type, //商标图样url
        isNeedSup: this.askForData.isNeedSup, //是否补充证据 '是' '否'
        docNo: this.$store.state.brandReview.reviewInfo.postNo, //发文号
        nclexist: this.$store.state.brandReview.reviewInfo.nclexist, //小类
      };
      downLoadFacts(params).then((res) => {
        if (res.status == 0) {
          this.downLoadUrl = res.data.word_url;
          window.open(this.downLoadUrl);
        } else if (res.status == -1) {
          this.$message("请完善申请人信息");
        }
      });
    },
    //保存申请人
    changeAppli() {
      this.applyUser.applicantName = this.$store.state.brandReview.reviewInfo.applicantName;
      this.applyUser.socialCreditCode = this.$store.state.brandReview.reviewInfo.assistant;
      let flag = false;
      for (let item in this.applyUser) {
        if (this.applyUser[item] == "") {
          flag = true;
        }
      }
      if (flag) {
        this.$message({ message: "请补全页面内的信息", type: "warning" });
      } else {
        this.$message({ message: "保存成功", type: "success" });
        this.$store.commit("brandReview/changeAppli", this.applyUser);
        this.drawer = false;
        this.submitApply() 
      }
    },
    //保存复审证据材料
    changeEvi() {
      if (this.askForData.isNeedSup) {
        //是否补充材料
        if (!this.askForData.evidenceDir) {
          this.$message({ message: "请上传证据目录", type: "warning" });
          return;
        } else if (!this.askForData.evidenceCon) {
          this.$message({ message: "请上传证据内容", type: "warning" });
          return;
        }
      }
      if (this.askForData.division) {
        //是否分割
        if (!this.askForData.divisionDir) {
          this.$message({ message: "请上传分割申请书", type: "warning" });
          return;
        }
      }
      if (!this.askForData.rrlb) {
        this.$message({ message: "请输入评审请求与法律依据", type: "warning" });
        return;
      } else if (!this.askForData.far) {
        this.$message({ message: "请输入主要事实与理由", type: "warning" });
        return;
      } else if (!this.askForData.farDir) {
        this.$message({ message: "请上传事实与理由文件", type: "warning" });
        return;
      } else {
        this.$message({ message: "保存成功", type: "success" });
        this.$store.commit("brandReview/changeEvi", this.askForData);
        this.table = false;
        this.submitApply() 
      }
    },
    // 提交驳回申请单
    submitApply() {
      let params = {
        orderNo: this.orderInfo.payNo,
        deliveryData: {
          //Y 交付单信息
          apply: {
            askforId: this.reviewInfo.caseNumber,
            tradeImg: this.reviewInfo.type,
            tradeType: this.reviewInfo.brandType,
            applicantName: this.reviewInfo.applicantName,
            usccode: this.reviewInfo.assistant,
            agentName: this.reviewInfo.agent,
          },
          applyUser: {
            applicantName: this.applicantInfo.applicantName,
            applicantType: this.applicantInfo.applicantType,
            usccode: this.applicantInfo.socialCreditCode,
            licenseAddr: this.applicantInfo.licenseAddress,
            licenseDir: this.applicantInfo.licenseDir,
            tel: this.applicantInfo.contactPhone,
            duty: this.applicantInfo.headPosition,
            addr: this.applicantInfo.contactAddress,
            entrust: this.applicantInfo.entrust,
            country: this.applicantInfo.applicantNationality,
            dutyName: this.applicantInfo.headName,
            contactsName: this.applicantInfo.contactName,
            email: this.applicantInfo.contactEmail,
            mailCode: this.applicantInfo.contactZipCode,
          },
          trademarkRejInfo: {
            noticeDate: this.reviewInfo.date1,
            noticeMode: this.reviewInfo.radio,
            zhichanNumber: this.reviewInfo.postNo,
            rejNotice: this.reviewInfo.applicationUrl,
            quotedTrademark: this.reviewInfo.trademarkUrl,
          },
          askForData: {
            division: this.evidenceMaterial.division,
            divisionDir: this.evidenceMaterial.divisionDir,
            evidenceCon: this.evidenceMaterial.evidenceCon,
            evidenceDir: this.evidenceMaterial.evidenceDir,
            evidenceSend: this.evidenceMaterial.evidenceSend,
            explain: this.evidenceMaterial.explain,
            far: this.evidenceMaterial.far,
            farDir: this.evidenceMaterial.farDir,
            isNeedSup: this.evidenceMaterial.isNeedSup,
            rmLicense: this.evidenceMaterial.rmLicense,
            rrlb: this.evidenceMaterial.rrlb,
          },
          supData: {
            dir: "",
            con: "",
          },
        },
      };
      bsubmit(params).then((res) => {
        if (res.status == 0) {
          console.log('123333')
        }
      });
    },
    // 上传
    pdfUpload(file) {
      this.fileUpload(file, "pdf");
      console.log(file);
    },
    // 上传申请人营业执照副本复印件
    fileUploadLicenseDir(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.applyUser.licenseDir = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    // 上传评审代理委托书
    fileUploadAttorney(file, type) {
      // Toast.loading({
      //     duration: 0,
      //     mask: true,
      //     message: "上传中..."
      // });
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.applyUser.entrust = pdfUploadUrl;
          console.log(pdfUploadUrl, "plpplplp");
          this.$message("上传成功");
        }
      });
    },

    // 上传证据目录（文件）
    fileUploadEvidenceDir(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.evidenceDir = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    // 上传证据内容（文件）
    fileUploadEvidenceCon(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.evidenceCon = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },

    // 上传分割申请书
    fileUploadDivisionDir(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.divisionDir = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    // 上传事实与理由
    fileUploadFarDir(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.farDir = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },

    // 上传送达证据
    fileUploadEvidenceSend(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.evidenceSend = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    // 上传其他有关说明文件
    fileUploadExplain(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.explain = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    // 上传原代理接触关系声明书
    fileUploadRmLicense(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let pdfUploadUrl = doc.getElementsByTagName("Location")[0].innerHTML;
          this.askForData.rmLicense = pdfUploadUrl;
          this.$message("上传成功");
        }
      });
    },
    //随机key
    setKey() {
      // name = name.substring(name.length - 5);
      var myDate = new Date();
      var key =
        "zc_" +
        Math.round(Math.random() * 10000) +
        myDate.getTime() +
        myDate.getFullYear() +
        myDate.getMonth() +
        myDate.getDate() +
        ".pdf";
      // this.$refs[flag].data.key = key;
      return key;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveRmLicense() {
      this.askForData.rmLicense = ""; //删除与原代理接触关系
    },
    handleRemoveExplain() {
      this.askForData.explain = ""; //删除其他有关说明文件
    },
    handleRemoveEvidenceSend() {
      this.askForData.evidenceSend = ""; //删除送达证据
    },
    handleRemoveFarDir() {
      this.askForData.farDir = ""; //删除事实理由文件
    },
    handleRemoveDivisionDir() {
      this.askForData.divisionDir = ""; //删除分割申请书
    },
    handleRemoveEvidenceCon() {
      this.askForData.evidenceCon = ""; //删除证据内容
    },
    handleRemoveEvidenceDir() {
      this.askForData.evidenceDir = ""; //删除证据目录
    },
    handleRemoveLicenseDir() {
      this.applyUser.licenseDir = ""; //删除营业执照
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeAvatarUpload(file) {
      const isPDF = file.type === "application/pdf";
      console.log(file);
      if (!isPDF) {
        this.$message.error("上传文件只能是 PDF 格式!");
      }
      return isPDF;
    },
  },
};
</script>
<style lang="scss" scoped>
#customerRequest {
  position: relative;
  height: 100%;
  overflow: hidden;
  .el-alert {
    width: 80%;
    margin: 0 auto;
    background-color: #d6e7ff;
    color: #3c74cb;
    margin-bottom: 20px;
    box-shadow: 0px -1px 0px 0px rgba(221, 221, 221, 1);
    /deep/.el-alert__icon {
      margin-left: 40px;
    }
  }
  .content {
    width: 80%;
    height: 500px;
    margin: 0 auto;
    background-color: #fff;
    white-space: nowrap;
    margin-bottom: 30px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .el-form {
      margin-left: 80px;
      /deep/.el-form-item__error {
        margin-top: 36px;
      }
      /deep/.el-form-item__label {
        font-size: 18px;
        font-weight: 900;
        margin-top: 10px;
      }
      .el-textarea {
        width: 402px;
        height: 125px;
        /deep/.el-textarea__inner {
          width: 100%;
          height: 125px;
        }
      }
      .addInformation {
        width: 20%;
        height: 100px;
        border: 1px dashed #d8d8d8;
        text-align: center;
        margin-left: 15px;
        margin-bottom: 50px;
        .el-icon-plus {
          font-size: 28px;
          color: #b3b3b3;
          margin-top: 20px;
          margin-bottom: 10px;
        }
        p {
          height: 20px;
        }
      }
    }
    /deep/.el-drawer {
      overflow: auto;
      .el-drawer__body {
        .drawerHead {
          width: 80%;
          height: 50px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          h2 {
            font-weight: 900;
          }
        }
        .drawerCenter {
          width: 80%;
          margin: 0 auto;
          h3 {
            margin: 10px 0;
            font-size: 16px;
            font-weight: 600;
          }
          .el-form {
            margin-left: 0px;
            margin-bottom: 20px;
            .el-select {
              .el-input {
                .el-input__suffix {
                  .el-input__suffix-inner {
                    .el-select__caret {
                      line-height: 35px;
                    }
                  }
                }
              }
            }
            .upload-demo {
              .el-upload {
                .el-button {
                  width: 75px;
                  height: 30px;
                  background-color: #fff;
                  color: #1c7dff;
                  border: 1px solid #1c7dff;
                  border-radius: 0px;
                }
              }
            }
            .el-form-item {
              margin-bottom: 0px;
            }
            /deep/.el-form-item__label {
              font-weight: 300;
              font-size: 14px;
              display: block;
              margin-top: 0px;
            }
            .el-input {
              width: 100%;
              height: 35px;
              /deep/.el-input__inner {
                border-radius: 0px;
                width: 100%;
                height: 35px;
                display: block;
              }
            }
          }
          .el-upload-dragger {
            width: 100px;
            height: 100px;
            display: table-cell;
            vertical-align: middle;
            .el-icon-plus {
              font-size: 28px;
              margin-bottom: 10px;
              color: #b3b3b3;
            }
          }
        }
        .drawerFooter {
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
          .el-button {
            width: 75px;
            height: 30px;
            border-radius: 0px;
            line-height: 7px;
          }
          .el-button:nth-child(1) {
            background-color: #1f7fff;
            color: #fff;
          }
          .el-button:nth-child(2) {
            border: 1px solid rgba(31, 127, 255, 1);
            color: #1f7fff;
          }
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .matter {
      position: absolute;
      right: 190px;
      bottom: 22px;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        i {
          color: #ff6a01;
        }
        .price {
          font-size: 28px;
          font-weight: 900;
          color: #ff6a01;
        }
      }
      .el-button {
        background-color: #ff6a01;
        font-size: 16px;
        width: 145px;
        height: 44px;
        color: #fff;
        margin-left: 30px;
        border-radius: 0px;
      }
    }
  }
}
</style>